export class AiChatSuggestion {
  constructor ({
    content,
    displayContent
  }) {
    this.content = content
    this.displayContent = displayContent
  }
}
